import { getEntity, getEntityMap } from 'data'
import { createSelector } from 'reselect'
import { getActiveNoteId } from 'data/publicUI/selectors'

export const getNote = (state, noteId) => getEntity(state, 'PublicNote', noteId)
export const getActiveNote = state =>
  getEntity(state, 'PublicNote', getActiveNoteId(state))

export const getAllNotes = state => getEntityMap(state, 'PublicNote')

function recursivelyGetNotePathIds(allNotes, noteId, parentNoteIds = []) {
  const note = allNotes.get(noteId)
  const parentNoteRef = note && note.get('parentNote')
  if (!parentNoteRef) {
    return parentNoteIds
  }
  const parentNoteId = parentNoteRef.get('id')
  return recursivelyGetNotePathIds(
    allNotes,
    parentNoteId,
    parentNoteIds.concat(parentNoteId)
  )
}

export const getActiveNoteAncestorsIds = createSelector(
  state => getEntityMap(state, 'PublicNote'),
  state => getActiveNoteId(state),
  (allNotes, activeNoteId) => {
    if (!activeNoteId) {
      return []
    }
    return recursivelyGetNotePathIds(allNotes, activeNoteId)
  }
)

export const getPublicNoteByToken = createSelector(
  state => getEntityMap(state, 'PublicNote'),
  (_, token) => token,
  (entities, token) => {
    return entities.find(note => note.get('publicShareToken') === token)
  }
)
